//
//  SDKDTGroupTree.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { ALL_TOKEN_TYPES, } from "../../../../model/enums/SDKTokenType";
import { TokenGroup } from "../../../../model/groups/SDKTokenGroup";
import { GroupTreeNode } from "./SDKDTGroupTreeNode";
import { buildParentChildrenMap } from "./SDKDTParentChildMapping";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Tree Implementation
export class GroupTree extends GroupTreeNode {
    // ---------------------
    // MARK: - Constructor
    constructor(backingElement) {
        // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        super(backingElement, null);
        this.childType = backingElement.tokenType;
        this.tree = this;
    }
    // ---------------------
    // MARK: - Construction
    static populate(root, elements, parentChildrenMap) {
        if (!root) {
            return null;
        }
        const tree = new GroupTree(root);
        tree.populate(parentChildrenMap);
        return tree;
    }
}
export function buildBrandedElementRoots(elements) {
    const result = new Map();
    const { childrenMap } = buildParentChildrenMap(elements);
    const roots = elements.filter((element) => element instanceof TokenGroup && element.isRoot);
    const brandIds = new Set(roots.map((e) => e.brandId));
    for (const brandId of brandIds) {
        const typeRoots = new Map();
        result.set(brandId, typeRoots);
        for (const type of ALL_TOKEN_TYPES) {
            const root = roots.find((r) => r.brandId === brandId && r.tokenType === type);
            // @ts-expect-error TS(2345): Argument of type 'TokenTreeElement | undefined' is... Remove this comment to see the full error message
            const tree = GroupTree.populate(root, elements, childrenMap);
            if (tree) {
                typeRoots.set(type, tree);
            }
        }
    }
    return result;
}
